/* Import ES6 Promise */
import 'es6-promise/auto'

/* Imports do NODE_MODULES */
import Vue from 'vue' // vuejs
import VueRouter from 'vue-router' // Biblioteca de rotas do vue
import { sync } from 'vuex-router-sync' // Biblioteca flux para compartilhamento de estados
import VeeValidate, {Validator} from 'vee-validate'; // Bliblioteca de validação, similiar ao jquery.validate
import ptBR from 'vee-validate/dist/locale/pt_BR'; // Arquivo de tradução do vee validade;
import VuejsDialog from 'vuejs-dialog'; // Biblioteca para dialogs (Alert, Confirm, etc)
 
/* Imports de arquivos criados por nós */
import routes from './routes' // Arquivo de configuração das rotas
import store from './store'  // Arquivo de configuração do vuex (flux)
import AppView from './components/App.vue' // Componente pai da aplicação
import { AclInstaller, AclCreate } from 'vue-acl'

import Print from 'vue-print-nb'
 
/* Utilizando Imports */
Vue.use(Print);
Validator.localize('ptBR', ptBR); // Anexando a tradução ao vee validate
Vue.use(VuejsDialog) // Biblioteca para dialogs (Alert, Confirm, etc)
Vue.use(VueRouter) // VueRouter (Biblioteca de rotas do vue)
Vue.use(AclInstaller)
Vue.use(VeeValidate, { // VeeValidate com as configurações
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'ptBR',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'is-success', // model is valid
    invalid: 'is-danger', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
});

/* Importando e utilizando biblioteca de paginação */
Vue.component('laravue-pagination', require('laravel-vue-pagination')); 

/* Instanciando o VueRouter (Rotas) */
var router = new VueRouter({
  routes: routes, // Arquivo routes importado anteriormente com as definições da rota
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

/* Middleaware executado antes de prosseguir pra rota solicitada */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) { // Se o parametro meta.requiresAuth da rota solicitada for true
    if (localStorage.getItem('token')) { // Se já existir token de autenticação no storage
      next() // Prossiga pra rota solicitada
    } else {
      console.log('Not authenticated') 
      localStorage.removeItem('token')
      next({ path: '/login' }) // Retorna pro componente login
    }
  } else { // Se a rota não estiver protegida (requiresAuth)
    next() // Prossiga pra rota solicitada
  }
})

sync(store, router) // Sincroniza o router com o vuex (flux)

/* Checa correspondência do token local com o registrado no vuex */
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}

let permissoesIniciais = ['public'];
if (store.state.user) {
  permissoesIniciais = ['public', ...store.state.user.permissoes];
}

/* Instanciando o vue acl (Permissões) */
var acl = new AclCreate({
  initial: permissoesIniciais,
  notfound: '/error',
  router,
  acceptLocalRules: false,
})

/* Instância do Vue  */
new Vue({
  useEslint: true, 
  el: '#root', // Local que o vue vai "enxergar". #root corresponde ao id da div dentro do index.html. 
  router: router, // Instância do VueRouter
  acl: acl,
  store: store, // Instância do Vuex
  render: h => h(AppView) // Componente Pai
})

export default acl;


// WEBPACK FOOTER //
// ./src/main.js